module.exports = __webpack_public_path__ + "static/img/皮带乘人越位监测.6a08758d.png";